export default {
    categories: {
        orderSaveFailed: 'Couldn\'t save the order.',
        name: 'Name',
        namePlaceholder: 'e.g. Dairy',
        newTitle: 'New shop category',
        edit: 'Edit category',
        delete: 'Delete category',
        deleteProducts: '{n} product will be left without a category. | {n} products will be left without a category.',
        cannotUndo: 'This can\'t be undone.',
        title: 'Shop categories',
        count: '{n} category | {n} categories',
        add: 'Add category',
        orderHint: 'The order sets your route through the shop — drag to change it.',
        drag: 'Drag to change the order',
        productsInCategory: '{n} product in this category | {n} products in this category',
        withoutCategory: '{n} product has no category — in the basket it goes to “No category”. | {n} products have no category — in the basket they go to “No category”.',
        position: 'position {n}',
        productsTitle: 'PRODUCTS · {n}',
        inMeals: 'in {n} meal | in {n} meals',
        noProducts: 'No product has this category yet. You can assign it in the product window.',
        mealsTitle: 'MEALS WITH THESE PRODUCTS · {n}',
        noMeals: 'No meal uses products from this category.',
        emptyTitle: 'No shop categories',
        emptyText: 'Categories group the basket in Shopping mode and sort the list by aisle.',
        deleteConfirm: 'Delete shop category?',
    },
    list: {
        addProductFailed: 'Couldn\'t add the product.',
        unknownProduct: 'Unknown product',
        item: 'Item',
        servings: '{n} serving | {n} servings',
        source: {
            meal: 'meal',
            semi: 'semi-product',
            product: 'product',
            custom: 'custom',
        },
        fields: {
            servings: 'Servings',
            servingsEditHint: 'Ingredient weights will be recalculated for this many servings',
            portionsEditHint: 'How many × {portion} to buy',
            amount: 'Amount',
            amountEditHint: 'How much to buy',
            name: 'Name',
            namePlaceholder: 'e.g. bin bags',
            weight: 'Weight',
            weightHint: 'Optional',
            customName: 'Custom name',
            orProduct: 'or a product',
            productPlaceholder: 'Search the product catalogue',
            amountHint: 'Grams or product portions — empty means 100 g',
            orMeal: 'or a meal',
            servingsHint: 'For a meal — empty means 1',
            orSemi: 'or a semi-product',
            semiPortions: 'Semi-product portions',
            semiPortionsHint: 'How many portions to buy — empty means 1',
        },
        addTitle: 'Add to list',
        editNamed: 'Edit “{name}”',
        editItem: 'Edit item',
        bulk: {
            title: 'Enter several items',
            label: 'Items',
            placeholder: 'bin bags\ntoothpaste\nE27 light bulb',
            hint: 'Each line will be saved as a separate item.',
            partial: 'Added {added} of {total} — {failed} weren\'t saved.',
            added: 'Added {n} item. | Added {n} items.',
        },
        clearConfirm: 'Clear the whole list?',
        removeSelectedConfirm: 'Delete {n} item? | Delete {n} items?',
        removeFailed: 'Couldn\'t delete {n} item. | Couldn\'t delete {n} items.',
        noCategory: 'No category',
        addedManually: 'Added manually',
        boughtCaps: 'BOUGHT',
        copyFailed: 'The browser didn\'t allow copying the list.',
        title: 'Shopping list',
        count: '{n} item | {n} items',
        addItem: 'Add item',
        filterLabel: 'Shop category filter',
        allCategories: 'All categories',
        searchCategories: 'Search categories…',
        dictateTitle: 'Dictate what to buy — products, semi-products, meals and things outside the database',
        dictate: 'Dictate',
        bulkTitle: 'Enter several items at once — line by line',
        bulkButton: 'Enter several',
        showListTitle: 'Show the list as text to copy',
        showList: 'Show list',
        shoppingModeTitle: 'Go through the list in the shop',
        shoppingMode: 'Shopping mode',
        quickAdd: 'QUICK ADD',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        selectedCount: '{n} selected | {n} selected',
        total: 'Total',
        removeSelected: 'Delete selected',
        clear: 'Clear list',
        deselect: 'Deselect',
        select: 'Select',
        collapseIngredients: 'Hide ingredients',
        showIngredients: 'Show ingredients',
        changeServings: 'Change number of servings',
        unmarkBought: 'Undo — still to buy',
        markBought: 'Mark as bought',
        removeFromList: 'Remove from list',
        semiComposition: 'SEMI-PRODUCT INGREDIENTS',
        semiNoIngredients: 'This semi-product has no saved ingredients.',
        mealComposition: 'MEAL INGREDIENTS',
        mealNoIngredients: 'This meal has no saved ingredients.',
        emptyCategoryTitle: 'Nothing in this category',
        emptyCategoryText: 'The shop category belongs to the product — custom items, meals and semi-products don\'t have one.',
        showAll: 'Show all',
        emptyTitle: 'The shopping list is empty',
        emptyText: 'Once the list is ready, Shopping mode will guide you through the shop by category.',
        bulkManyAtOnce: 'Enter several at once',
        removeConfirm: 'Remove from the shopping list?',
        clearConfirmText: 'All items will disappear, including those added from meals and semi-products. This can\'t be undone.',
        textTitle: 'List to buy',
        textEmpty: 'The basket is empty.',
        close: 'Close',
        copied: 'Copied',
        copy: 'Copy',
    },
    stores: {
        andMore: '{names} and {n} more | {names} and {n} more',
        storeName: 'Shop name',
        storeNamePlaceholder: 'e.g. Tesco',
        newStore: 'New shop',
        editStore: 'Edit shop',
        itemName: 'Name',
        itemNamePlaceholder: 'e.g. milk',
        store: 'Shop',
        storeEditHint: 'Changing this moves the item from this shop to the selected one — other assignments stay',
        storeNewHint: 'One item can be in many shops — add it in each one',
        saveItemFailed: 'Couldn\'t save the item.',
        deleteItemFailed: 'Couldn\'t delete the item.',
        addItemFailed: 'Couldn\'t add the item.',
        subtitle: '{n} shop · your shopping list in one place | {n} shops · your shopping list in one place',
        productCount: '{n} product | {n} products',
        title: 'Shops',
        searchLabel: 'Search for a shop or product',
        searchPlaceholder: 'Search for a shop or product…',
        filters: 'Sort and filters',
        sort: 'SORT',
        sortName: 'Alphabetically',
        sortCount: 'Most products',
        hideEmpty: 'Hide empty shops',
        uncheckAll: 'Untick all ({n})',
        removeBoughtTitle: 'Remove all ticked items from the shop lists',
        removeBought: 'Remove bought ({n})',
        addStore: 'Add shop',
        boughtCount: '{n} bought',
        more: 'More',
        moreLabel: 'More shop options',
        rename: 'Rename',
        uncheckStore: 'Untick in this shop',
        deleteStore: 'Delete shop',
        undo: 'Undo',
        also: 'also: {stores}',
        deleteItem: 'Delete item',
        noProducts: 'No products',
        noProductsHint: 'Add the first product to this list.',
        addProductTo: 'Add a product to: {name}',
        addProductPlaceholder: 'Add a product…',
        addProduct: 'Add product',
        noMatch: 'No matches',
        noMatchText: 'No shop or product matches your search.',
        emptyTitle: 'No shops',
        emptyText: 'Shops organise the shopping list by place.',
        deleteStoreConfirm: 'Delete shop?',
        deleteStoreMessage: 'Items assigned only to this shop will lose their shop.',
        newItem: 'New item',
        removeCheckedConfirm: 'Delete {n} ticked item? | Delete {n} ticked items?',
        removeCheckedMessage: 'They\'ll disappear from every shop they\'re in.',
        deleteItemConfirm: 'Delete item?',
        deleteItemMessage: 'It will disappear from every shop it was in.',
    },
    mode: {
        left: '{left} of {all} left to get',
        uncheckAll: 'Untick all',
        finish: 'Finish',
        loading: 'Loading basket…',
        loadFailed: 'Couldn\'t load the basket.',
        retry: 'Try again',
        taken: '{name} · taken',
        emptyTitle: 'The basket is empty',
        emptyText: 'Add something to the shopping list and it will appear here.',
    },
    review: {
        kind: {
            product: 'Product',
            semiProduct: 'Semi-product',
            meal: 'Meal',
            newProduct: 'New product',
            custom: 'Name only',
        },
        servingsUnit: 'servings',
        increased: '{name} +{amount}',
        increasedTotal: '{name} +{amount} (total {total})',
        newProductNote: '(new product)',
        goneFromDb: 'Something on the list has disappeared from the database in the meantime — choose the match again.',
        addFailed: 'Couldn\'t add the items — try again.',
        nothingLeft: 'Nothing left to add.',
        nameLabel: 'Name: {text}',
        heard: '“{text}”',
        remove: 'Remove from preview',
        optional: 'optional',
        nameOnlyTitle: 'No product in the database — e.g. things that aren\'t food',
        asNewTitle: 'Add to the database as a new product',
        asNew: 'As a new product',
        onList: 'Already on the list: {amount}',
        addSeparately: 'Add separately',
        addToExisting: 'Add to the existing one',
        maybe: 'Maybe:',
        pickFromDb: 'Choose from the database',
        searchPlaceholder: 'Search for a product, semi-product or meal…',
        notFound: 'Nothing like that in the database.',
        skip: 'Skip',
        addCount: 'Add {n} item | Add {n} items',
    },
};
